import React, { FC, ReactNode } from 'react';

const OfferPrice: FC<{ children?: ReactNode }> = ({ children }) => (
  <span className="Offer-Price text-grey-1 font-normal text-md">
    {children}
  </span>
);

export default OfferPrice;
